import { useMemo } from "react";
import { useI18nContext } from "@hopper-b2b/i18n";
import type { CustomerReviewsSectionComponentProps } from "./CustomerReviewsSection";

const COMMENTS_TO_SHOW = 2;

export const useCustomerReviewsSection = ({
  reviews,
}: CustomerReviewsSectionComponentProps) => {
  const { t } = useI18nContext();

  const reviewsToDisplay = useMemo(
    () => reviews.comments.slice(0, COMMENTS_TO_SHOW) ?? [],
    [reviews.comments]
  );

  const overallRating = reviews.overallScore * 5;

  return useMemo(() => {
    return {
      context: {
        reviewsToDisplay,
        comments: reviews.comments,
        reviews,
        overallRating: overallRating,
        reviewsCount: reviews.reviewsCount,
      },
      text: {
        title: t("core-hotels.shop.customerReviews.title"),
        ratingAverage: t("core-hotels.shop.customerReviews.averageRating", {
          averageRating: overallRating.toFixed(1),
        }),
        reviewCount: t("core-hotels.shop.customerReviews.reviewCount", {
          count: reviews.reviewsCount,
        }),
        moreReviews: t("core-hotels.shop.customerReviews.moreReviews"),
      },
    };
  }, [overallRating, reviews, reviewsToDisplay, t]);
};
